/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LazyImageWrapper_item$ref: FragmentReference;
export type LazyImageWrapper_item = {|
  +photos: ?$ReadOnlyArray<?{|
    +placeholder: ?string
  |}>,
  +$refType: LazyImageWrapper_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LazyImageWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": "photos(limit:1,skipImageService:true)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "skipImageService",
          "value": true,
          "type": "Boolean"
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "placeholder",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '525f17edc242bcc39550cd92eac6ad65';
module.exports = node;
